import React from "react";
import SharedCTASection from "../../SharedCTASection";

const OurValuesandMeetOurTeam = () => {
  return (
    <>
      <SharedCTASection />
    </>
  );
};

export default OurValuesandMeetOurTeam;
